/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";
import { toast } from "react-toastify";

interface Props {
  idEmpreendimento: string | null;
  enabled?: boolean;
}

export const useGetStandEspelho = (props: Props) => {
  const fetchData = async () => {
    const url = `locais/app-web/produtos/detalhes-por-idEmpreendimento/v1?idEmpreendimento=${props.idEmpreendimento}`;
    const response = await instance.get(url);
    return response?.data;
  };

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["get-stand-espelho", props.idEmpreendimento],
    enabled: (props.enabled ?? false) && !!props.idEmpreendimento,
    refetchOnWindowFocus: false,
    onError: (error: any) => {
      toast.error(
        `Erro ao buscar stand espelho. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return query;
};
